import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchMealTypes = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/meal-types', { pagination: false }).then(response => {
    dispatch({
      type: types.FETCH_MEALTYPES,
      payload: {
        mealTypes: response['hydra:member'],
      },
    });
    return response['hydra:member'];
  });

export const fetchMealType = (id, params) => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/meal-types/${id}`, params).then(response => {
    dispatch({
      type: types.FETCH_MEALTYPE,
      payload: {
        name: response.name,
        position: response.position,
        sizes: response.sizes,
      },
    });
    return response;
  });

export const removeMealType = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/meal-types/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_MEALTYPE,
      payload: {
        mealTypeId: id,
      },
    });
  });
